import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import debounce from "lodash/debounce";

gsap.registerPlugin(ScrollTrigger);

function adjustFontSize(element) {
  const textEls = element.querySelectorAll(".callout-item p");

  let minFontSize = Infinity;

  textEls.forEach((element) => {
    element.style.whiteSpace = "nowrap";
    element.style.fontSize = "100px";
  });

  textEls.forEach((element) => {
    const containerWidth = element.parentElement.offsetWidth;
    const containerHeight = element.parentElement.offsetHeight;
    let fontSize = 100;

    while ((element.scrollWidth > containerWidth || element.scrollHeight > containerHeight) && fontSize > 1) {
      fontSize -= 1;
      element.style.fontSize = `${fontSize}px`;
    }

    minFontSize = Math.min(minFontSize, fontSize);

    element.style.fontSize = null;
  });

  element.style.setProperty("--font-size", `${minFontSize}px`);
}

document.querySelectorAll(".element-callouttext").forEach((el) => {
  const marker = el.querySelector(".callout-marker");
  const holder = el.querySelector(".callout-items");
  const items = Array.from(el.querySelectorAll(".callout-item"));
  let isPinned = false;

  let activeIndex = 0;

  adjustFontSize(el);

  const resizeObserver = new ResizeObserver(
    debounce(() => {
      if (!isPinned) {
        adjustFontSize(el);
      }
    }, 125),
  );

  resizeObserver.observe(el);

  const start = () => {
    setInterval(() => {
      const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;

      items[activeIndex].classList.remove("is-active");

      const markerY = Math.abs(holder.getBoundingClientRect().top - items[nextIndex].getBoundingClientRect().top);

      gsap.to(marker, { y: markerY, duration: 0.5, ease: "cubic-bezier(.5,.5,0,1)" });

      items[nextIndex].classList.add("is-active");

      activeIndex = nextIndex;
    }, 2000);
  };

  const runTimeline = () => {
    const timeline = gsap.timeline({
      paused: true,
      scrollTrigger: {
        trigger: el.querySelector(".element-wrapper"),
        start: () => {
          const siteHeaderHeight = parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue("--site-header-height"),
          );
          const offset = siteHeaderHeight + 24;

          return `top ${offset}`;
        },
        end: () => {
          return `bottom+=${items.length * 100}% bottom`;
        },
        onEnter: () => {
          isPinned = true;
        },
        onLeave: function (self) {
          let start = self.start;
          self.scroll(self.start);
          self.disable(false, true);
          ScrollTrigger.refresh();
          window.scrollTo(0, start);
        },
        pin: true,
        scrub: true,
        once: true,
        markers: false,
      },
      onComplete: () => {
        setTimeout(() => {
          gsap.to(marker, {
            y: () => {
              return Math.abs(holder.getBoundingClientRect().top - items[0].getBoundingClientRect().top);
            },
            duration: 0.5,
            ease: "cubic-bezier(.5,.5,0,1)",
          });

          items[0].classList.add("is-active");
          items[items.length - 1].classList.remove("is-active");

          start();

          isPinned = false;
        }, 1000);
      },
    });

    timeline.fromTo(marker, { opacity: 0 }, { opacity: 1 });

    items.forEach((item, index) => {
      if (index === 0) {
        timeline.to(
          marker,
          {
            y: () => {
              return Math.abs(holder.getBoundingClientRect().top - item.getBoundingClientRect().top);
            },
            ease: "cubic-bezier(.5,.5,0,1)",
            onUpdate: function () {
              const progress = this.progress();
              const direction = timeline.scrollTrigger.direction;

              if (direction > 0 && progress > 0.5) {
                item.classList.add("is-active");
              }

              if (direction < 0 && progress > 0.5) {
                item.classList.add("is-active");
              }

              if (direction < 0 && progress < 0.5) {
                item.classList.remove("is-active");
              }
            },
            onReverseComplete: () => {
              item.classList.remove("is-active");
            },
          },
          "<",
        );
      } else {
        timeline.to(marker, {
          y: () => {
            return Math.abs(holder.getBoundingClientRect().top - item.getBoundingClientRect().top);
          },
          ease: "cubic-bezier(.5,.5,0,1)",
          onUpdate: function () {
            const progress = this.progress();
            const direction = timeline.scrollTrigger.direction;

            if (direction > 0 && progress > 0.5) {
              item.classList.add("is-active");
            }

            if (direction < 0 && progress > 0.5) {
              item.classList.add("is-active");
            }

            if (direction < 0 && progress < 0.5) {
              item.classList.remove("is-active");
            }
          },
          onReverseComplete: () => {
            item.classList.remove("is-active");
          },
        });
      }

      if (index < items.length - 1) {
        timeline.to(item, {
          duration: 1,
          onUpdate: function () {
            const direction = timeline.scrollTrigger.direction;
            if (direction < 0) {
              item.classList.add("is-active");
            }
          },
          onComplete: () => item.classList.remove("is-active"),
        });
      } else {
        timeline.to(item, { duration: 1 });
      }
    });
  };

  const rect = el.getBoundingClientRect();
  const elementBottom = rect.top + rect.height;
  const scrollY = window.scrollY;
  const windowHeight = window.innerHeight;
  const scrollIsPastElement = scrollY > elementBottom + scrollY - windowHeight;

  if (scrollIsPastElement || document.documentElement.classList.contains("is-scrolling")) {
    start();
  } else {
    runTimeline();
  }
});
